"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "useOnOutsideClick", {
    enumerable: true,
    get: ()=>useOnOutsideClick
});
const _interopRequireDefault = require("@swc/helpers/lib/_interop_require_default.js").default;
const _interopRequireWildcard = require("@swc/helpers/lib/_interop_require_wildcard.js").default;
const _react = /*#__PURE__*/ _interopRequireWildcard(require("react"));
const _flatMap = /*#__PURE__*/ _interopRequireDefault(require("lodash/flatMap"));
function useOnOutsideClick(rootRef, callback, enabled = true, checkOutsideFn) {
    (0, _react.useEffect)(()=>{
        if (!enabled) {
            return;
        }
        const checkOutsideClick = (e)=>{
            const target = e.target;
            const roots = (Array.isArray(rootRef) ? (0, _flatMap.default)(rootRef, (ref)=>{
                if (typeof ref === 'string') {
                    const elements = document.querySelectorAll(ref);
                    return Array.from(elements);
                }
                return ref.current;
            }) : [
                rootRef.current
            ]).filter((node)=>!!node);
            if (roots.length === 0) {
                return;
            }
            if (// any of the roots contains our target
            roots.some((root)=>root.contains(target)) || // or it has ignore-enforcing ancestors
            target.closest('.ignore-react-onclickoutside') || // or the custom checking method says the element is inside
            (checkOutsideFn && !checkOutsideFn(target, e))) {
            // this was an inside click, nothing to see here
            } else {
                callback(e);
            }
        };
        document.addEventListener('mousedown', checkOutsideClick);
        document.addEventListener('touchstart', checkOutsideClick);
        return ()=>{
            document.removeEventListener('mousedown', checkOutsideClick);
            document.removeEventListener('touchstart', checkOutsideClick);
        };
    }, [
        callback,
        rootRef,
        enabled,
        checkOutsideFn
    ]);
}
